import React from 'react';
import './App.css';
import MultiEmailGenerator from './MultiEmailGenerator';

function App() {
  return (
    <div className="App">
      <MultiEmailGenerator />
    </div>
  );
}

export default App;